import { boolean, number, object, string, union, z } from "zod";

import { LadyMinV2MainPhotoDTORaw } from "@/models/lady-dtos";

export const GetLeftInfoResponseDTOError = object({
  requestDTO: object({
    dataMap: object({
      error: string(),
    }),
  }),
});

export const GetLeftInfoResponseDTOSuccess = object({
  balance: object({
    userID: number(),
    coins: number(),
    bonusEmailRead: number(),
    bonusCoins: number(),
    isReplenished: boolean(),
  }),
  userAccess: boolean(),
  unreadAdminMail: number(),
  unreadMail: number(),
  user: object({
    id: number(),
    mainPhotoID: number().optional(),
    isOnline: boolean(),
    url: string().optional(),
    mainPhotoDTO: LadyMinV2MainPhotoDTORaw.optional(),
  }),
});

export type GetLeftInfoResponseDTOSuccess = z.infer<
  typeof GetLeftInfoResponseDTOSuccess
>;

export const successDto = (response: GetLeftInfoResponseDTO) =>
  GetLeftInfoResponseDTOSuccess.safeParse(response);

export type GetLeftInfoResponseDTOError = z.infer<
  typeof GetLeftInfoResponseDTOError
>;

export const GetLeftInfoResponseDTO = union([
  GetLeftInfoResponseDTOError,
  GetLeftInfoResponseDTOSuccess,
]);

export type GetLeftInfoResponseDTO = z.infer<typeof GetLeftInfoResponseDTO>;
